'use client';

export const setCookie = (name: string, object: Record<string, any>, days: number) => {
    // Convert the object into a JSON string
    const jsonString = JSON.stringify(object);

    // Create a Date object for the expiration date
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));

    // Set the cookie with the JSON string as its value and HTTP-only flag
    document.cookie = `${name}=${encodeURIComponent(jsonString)};expires=${expires.toUTCString()};path=/`;
};

export const getCookie = (name: string) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        const entry = parts.pop();
        if (entry) {
            const raw = entry.split(';').shift();
            if (raw) {
                const decoded = decodeURIComponent(raw);
                if (decoded) {
                    try {
                        const parsed = JSON.parse(decoded);
                        return parsed;
                    }
                    catch (e) {
                        console.error('Unable to parse cookie:', e);
                        return null;
                    }
                }
            }
        }
    }
    return null;
};

export const clearCookie = (name: any) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`
};
